module.exports = __webpack_public_path__ + "img/jp.ae0f5711.svg";